import { Skeleton } from '@pets-ui/Skeleton/Skeleton'
import { VStack } from '@pets-ui/VStack/VStack'

export interface CouponListSkeletonsProps {
  rows: number
}

export const CouponListSkeletons = ({ rows }: CouponListSkeletonsProps) => (
  <VStack gap={2}>
    {Array.from({ length: rows }).map((_, index) => (
      <Skeleton key={index} variant="rounded" height={36} />
    ))}
  </VStack>
)
